module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep7_Food_as_medicine_Desktop.edca5fb9.jpg";